import { hits } from "instantsearch.js/es/widgets";

// services badges
function getServicesHtml(services = []) {
  if (!services.length) return "";
  return `<div class="card-footer h-25 px-2 py-3">
    ${services
      .map(
        (s) => `
        <div class="d-inline p-0">
          <span class="badge rounded-pill bg-light text-dark me-1">${s.name}</span>
        </div>`,
      )
      .join("")}
    </div>
  `;
}

// rating stars
function getRatingHtml(ratings = {}) {
  const { overall_rating = 0, total_reviews = 0 } = ratings;
  if (total_reviews === 0) return "";

  const fullStars = Math.floor(overall_rating);
  const emptyStars = 5 - fullStars;

  return `<div class="text-warning">
      ${"★".repeat(fullStars)}${"☆".repeat(emptyStars)}
      <small class="text-muted">${overall_rating}</small>
    </div>
  `;
}

const cardHeader = (hit) => {
  return `<div class="w-100 position-relative">
    <img class="w-100 card-img-top" src="${
      hit.avatar
    }" style="aspect-ratio: 1" alt="${hit.name} - ${hit.country?.name}">
      <span class="bg-primary search-account-type">${hit.account_type}</span>
        ${
          hit.country
            ? `<span class="search-country-flag rounded flag-icon flag-icon-${hit.country.country_code}"></span>`
            : ""
        }
    </div>`;
};

function getHitsHtml(locale, countryCode, hit) {
  return `<div class="card shadow-sm border-0 rounded">
    <a href="/${countryCode}/${locale}/p/${
      hit.slug
    }" class="stretched-link" target="_blank" rel="noreferrer"></a>
    <div class="card-body p-0 h-100 mh-100">
      ${cardHeader(hit)}
      <div class="p-3">
        <h5 class="mb-0">${hit.name}</h5>
        ${getRatingHtml(hit.aggregate_ratings)}
        <p class="small text-muted text-truncate">${hit.description || ""}</p>
      </div>
    </div>
    ${getServicesHtml(hit.services)}
  </div>`;
}

const hitsWidget = (locale, countryCode, I18n) =>
  hits({
    container: "#hits",
    templates: {
      empty: I18n.translate("stimulus.professional_search.no_results"),
      item(hit) {
        return getHitsHtml(locale, countryCode, hit);
      },
    },
    cssClasses: {
      item: "col-lg-4 col-md-6 mb-4 col-6 h-25",
      list: "d-flex flex-row flex-wrap list-unstyled",
      emptyRoot: "text-center my-5",
    },
  });

export default hitsWidget;
